import { useQuery } from "@tanstack/react-query";
import useApi from "../utils/useApi";

export default function useCameras() {
  const { getCameras } = useApi();

  const { data, isLoading } = useQuery({
    queryKey: ["camerasCount"],
    queryFn: getCameras,
  });

  const cameras = data?.data;

  return { data: cameras, camerasCount: cameras?.length, isLoading };
}
